export default __webpack_public_path__ + "static/topline-575e6480ba5b899201dc2e03699f618f.webp";